import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { CustomTranslateModule, PipesModule } from '@flowaccount/landing'
import { Price2021DesktopComponent } from './price2021-desktop/price2021-desktop.component'
import { Price2021MobileComponent } from './price2021-mobile/price2021-mobile.component'

@NgModule({
  imports:[
    CommonModule,
    CustomTranslateModule.forChild({ path: 'pricing' }),
    PipesModule
  ],
  declarations: [
    Price2021DesktopComponent,
    Price2021MobileComponent
  ],
  exports: [
    Price2021DesktopComponent,
    Price2021MobileComponent
  ]
})
export class Price2021Module { }
